"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var reconnect_js_1 = require("reconnect.js");
function BreadcrumbBar(props) {
  var categoryDisplayMap = (0, reconnect_js_1.useOutlet)(props.categoryDisplayMap)[0];
  var actions = (0, reconnect_js_1.useOutlet)('actions')[0];
  var _a = props.cat,
    cat = _a === void 0 ? '' : _a,
    updateCat = props.updateCat,
    _b = props.instanceId,
    instanceId = _b === void 0 ? '' : _b,
    _c = props.instanceDisplay,
    instanceDisplay = _c === void 0 ? '' : _c,
    _d = props.updateInstance,
    updateInstance = _d === void 0 ? function () {
      return 0;
    } : _d;
  var catItems = cat.split('-');
  var onCatClick = function (idx) {
    return function () {
      updateCat(catItems.slice(0, idx + 1).join('-'));
    };
  };
  var getCatDisplay = function (idx) {
    return categoryDisplayMap[catItems.slice(0, idx + 1).join('-')];
  };
  var onInstanceClick = function (id) {
    return function () {
      return updateInstance(id);
    };
  };
  return react_1.default.createElement(antd_1.Breadcrumb, {
    style: {
      cursor: 'pointer'
    }
  }, react_1.default.createElement(antd_1.Breadcrumb.Item, {
    onClick: function () {
      updateCat('');
    }
  }, actions.L('all_categories')), catItems.map(function (_, idx) {
    return react_1.default.createElement(antd_1.Breadcrumb.Item, {
      key: idx,
      onClick: onCatClick(idx)
    }, getCatDisplay(idx));
  }), instanceId && react_1.default.createElement(antd_1.Breadcrumb.Item, {
    onClick: onInstanceClick(instanceId)
  }, instanceDisplay));
}
exports.default = BreadcrumbBar;